/**
 * repeatedly call a function for a specified duration
 *
 * @param {function} func - the function to continuously call
 * @param {number} duration - amount of time to wait before stopping, in ms
 * @param {number} delay - the delay between function calls, in ms
 */
const callForDuration = ( func: Function, duration: number = 1000, delay: number = 1 ): void =>
{
	const startTime = performance.now();
	const interval  = setInterval( () =>
	{
		const elapsed = performance.now() - startTime;

		if (elapsed < duration) {
			func();
		} else {
			clearInterval( interval );
		}

	}, delay );

	func();
};


/**
 *
 */
export {callForDuration};